import React from "react";
import useStore from "../../context/useStore";
import { Route, Redirect } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { redirectionPourOperateur } from "../../helpers/perimetreOperateur";
import Login from "../pages/Login/Login";
import RenewPasswordLoggedIn from "../pages/RenewPassword/RenewPasswordLoggedIn";

// Route réservée aux utilisateurs connectés. Un compte d'opérateur
// d'accompagnement (CE-1407) ne voit que sa structure : toute autre page le
// renvoie à /ma-structure (helpers/perimetreOperateur).
const PrivateRoute = ({ component: Component, ...rest }) => {
  const [state] = useStore();

  return state.auth.isLoading ? (
    <ClipLoader />
  ) : (
    <Route
      {...rest}
      render={(props) => {
        if (state.auth.isAuthenticated !== true) return <Login />;
        if (state.auth.user.mustRenewPassword) return <RenewPasswordLoggedIn />;
        const redirection = redirectionPourOperateur(state.auth.user, props.location.pathname);
        if (redirection) return <Redirect to={redirection} />;
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
